"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _shader = _interopRequireDefault(require("./shader"));

//blue
var blueBase = '#3666BD';
var blue = {
  dark40: (0, _shader["default"])(-0.4, blueBase),
  //#09101E
  dark30: (0, _shader["default"])(-0.3, blueBase),
  //#142646
  dark20: (0, _shader["default"])(-0.2, blueBase),
  //#1F3B6E
  dark10: (0, _shader["default"])(-0.1, blueBase),
  //#2B5195
  base: blueBase,
  light10: (0, _shader["default"])(0.1, blueBase),
  //#5782CF
  light20: (0, _shader["default"])(0.2, blueBase),
  //#7F9FDA
  light30: (0, _shader["default"])(0.3, blueBase),
  //#A6BDE6
  light40: (0, _shader["default"])(0.4, blueBase),
  //#CEDAF1
  light45: (0, _shader["default"])(0.45, blueBase) //#E2E9F7

};
var _default = blue;
exports["default"] = _default;